// Halloween costumes. Pure and by seed only: the function never sees who is an alien,
// so a costume cannot change, hide or hint at it. Used only while the edition is on.
export const COSTUMES = ['mask', 'sheet', 'pumpkin'];

// Share of visitors in costume, and the split between the kinds (the rest wear none).
export const COSTUME_SHARE = 0.6;

const fmix = h => { h >>>= 0; h ^= h >>> 16; h = Math.imul(h, 0x85ebca6b); h ^= h >>> 13; h = Math.imul(h, 0xc2b2ae35); h ^= h >>> 16; return h >>> 0; };

// seed: the same number the look is made from (seedOf(visitor id)). Returns 'mask' | 'sheet' | 'pumpkin' | null.
export function costumeOf(seed, { halloween = false, outbreak = false } = {}) {
  if (!halloween || outbreak) return null;
  const h = fmix((seed ^ 0x3c6ef372) >>> 0);
  if (h / 4294967296 >= COSTUME_SHARE) return null;
  return COSTUMES[fmix(h ^ 0x9e3779b9) % COSTUMES.length];
}
